export interface GlobalOccasionOption {
    key: string;
    label: string;
    entries: GlobalOccasionOptionSection[];
}

export interface GlobalOccasionOptionSection {
    label: string;
}

export const globalOccasionOptions: GlobalOccasionOption[] = [
    {
        key: "protectProperty",
        label: "Eigentum erhalten",
        entries: [
            { label: "... mein Eigenheim absichern" },
            { label: "... mein Hab und Gut schützen" },
            { label: "... eine Absicherung für mein Fahrzeug haben" },
        ],
    },
    {
        key: "protectWealth",
        label: "Vermögen schützen",
        entries: [
            { label: "... mein Vermögen sichern" },
            {
                label: "... vor Schadensersatzansprüchen Dritter geschützt sein",
            },
            { label: "... meine Ansprüche rechtlich durchsetzen können" },
        ],
    },
    {
        key: "protectIncome",
        label: "Einkommen sichern",
        entries: [
            { label: "... eine gute Absicherung meiner Familie" },
            { label: "... mein regelmäßiges Einkommen sichern" },
            { label: "... staatliche Förderung nutzen können" },
        ],
    },
    {
        key: "createWealth",
        label: "Vermögen bilden",
        entries: [
            { label: "... kontinuierliches Vermögen aufbauen" },
            { label: "... meine Rendite überprüfen" },
            { label: "... meinen Kindern einen guten Weg ebnen" },
        ],
    },
    {
        key: "precautions",
        label: "Vorsorge optimieren",
        entries: [
            {
                label: "... meinen Lebensstandard im Alter sichern oder Vermögen aufbauen",
            },
            { label: "... meine Angehörigen absichern" },
            { label: "... meine Arbeitskraft absichern" },
            //{ label: "... Vermögen aufbauen" },
        ],
    },
];
